// @ts-nocheck
import { useEffect, useContext, FC, useState } from 'react'
import { startOfMonth, endOfMonth, eachDayOfInterval, getDay, subDays, addDays } from 'date-fns'
import { Center, Spinner } from '@chakra-ui/react'
import MiniCalendarContext, { MiniCalendarType } from './Context'

type PeriodProps = {
  start?: string | Date
  final?: string | Date
}

type Props = {
  children: JSX.Element
  period?: PeriodProps
  withoutControls?: boolean
}

const MiniCalendarProvider: FC<Props> = ({
  children,
  period,
  withoutControls = false,
  defaultView = 'MONTH',
  dataOfTheDays,
  DayOfTheMonthComponent,
}) => {
  const [loadingCalendar, setLoadingCalendar] = useState(true)
  const [view, setView] = useState(defaultView)
  const [activeDay, setActiveDay] = useState<Date | number>(0)
  const [days, setDays] = useState<Date[]>([])
  const [calendarWith6LinesOfDays, setCalendarWith6LinesOfDays] = useState(false)

  useEffect(() => {
    async function prepareMonth() {
      if (!activeDay) return

      const startOfMonthDate = startOfMonth(new Date(activeDay))
      const endOfMonthDate = endOfMonth(new Date(activeDay))

      // dias do mês (clonando o array)
      const eachDayInTheMonthRange = eachDayOfInterval({
        start: startOfMonthDate,
        end: endOfMonthDate,
      })
      const daysToCalendar = [...eachDayInTheMonthRange]

      // quantos dias antes do 1º do mês devem aparecer (0..6)
      const firstDayOfTheWeek = getDay(startOfMonthDate)

      // **Use startOfMonthDate como base fixa** (corrige o bug)
      for (let i = 1; i <= firstDayOfTheWeek; i++) {
        daysToCalendar.unshift(subDays(startOfMonthDate, i))
      }

      // decidir linhas (5 ou 6)
      const numberOfDaysShownOnTheCalendar = daysToCalendar.length > 35 ? 42 : 35
      setCalendarWith6LinesOfDays(numberOfDaysShownOnTheCalendar === 42)

      // completar com dias após o fim do mês
      const quantityOfDaysToCloseTheLine = numberOfDaysShownOnTheCalendar - daysToCalendar.length
      for (let i = 1; i <= quantityOfDaysToCloseTheLine; i++) {
        daysToCalendar.push(addDays(endOfMonthDate, i))
      }

      setDays(daysToCalendar)
      setLoadingCalendar(false)
    }

    // inicializa activeDay se necessário e prepara mês
    if (!activeDay) {
      setActiveDay(Date.now())
    } else {
      prepareMonth()
    }
  }, [view, activeDay])

  if (loadingCalendar) {
    return (
      <Center w="full">
        <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="primary.500" size="xl" />
      </Center>
    )
  }

  return (
    <MiniCalendarContext.Provider
      value={{
        days,
        view,
        setView,
        activeDay,
        setActiveDay,
        calendarWith6LinesOfDays,
        period,
        withoutControls,
        defaultView,
        dataOfTheDays,
        DayOfTheMonthComponent,
      }}
    >
      {children}
    </MiniCalendarContext.Provider>
  )
}

export default MiniCalendarProvider

export const useMiniCalendar = () => useContext<MiniCalendarType>(MiniCalendarContext)
